import React from 'react';
import { CashBack } from '@lt/components';
import classnames from 'classnames';
import styles from './headerAuth.module.css';
import HeaderAvatarMenuItem from './components/HeaderAvatarMenuItem/HeaderAvatarMenuItem';

interface IconComponentProps {
  isWhiteLabel: boolean;
  isCompact: boolean;
  isLoggedIn: boolean;
  clientAvatar: string;
  bonusScore: number;
}

export const getIconComponent = ({
  isWhiteLabel,
  isCompact,
  isLoggedIn,
  clientAvatar,
  bonusScore,
}: IconComponentProps) => {
  if (isWhiteLabel) {
    return (
      <div
        className={classnames(styles.avatar, {
          [styles.avatarCompact]: isCompact,
        })}
        style={{
          backgroundImage: clientAvatar ? `url(${clientAvatar})` : 'auto',
        }}
      />
    );
  }

  if (isLoggedIn && !isCompact) {
    return <HeaderAvatarMenuItem clientAvatar={clientAvatar} />;
  }

  return (
    <CashBack
      count={bonusScore}
      avatarPath={clientAvatar}
      size="l"
      isMobile={false}
      hasCashbackLabel={false}
    />
  );
};
